import { connect } from "react-redux";
import { ApplicationStore } from "src/store";
import PowerUserTools from "./PowerUserTools";

export function mapStateToProps({ onlineShopper }: ApplicationStore) {
    return {
        visibled: onlineShopper.powerUserToolsVisibled,
    };
}

export default connect(mapStateToProps)(PowerUserTools);
